import { createExperiment } from 'shared/experiment/hook';

type PrePackageExperiments = { [key: string]: string };

const { ExperimentProvider, useExperiment } = createExperiment<PrePackageExperiments>();

export { ExperimentProvider, useExperiment };
